export const BASE_RATE = "$6.99";
export const IC_DISCOUNT_RATE = "$2.99";
